
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getDiceGameBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/dice-game/my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const diceGamePlaceBet = ({ data, isDemoGame }) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/dice-game/place-bet', data, {
    server: microServices.SERVICE_URL_1,
    headers: { 'demo-game': isDemoGame },
    loader: LOADER_HANDLER_TYPES.submit
  })
}
